import { render } from "./HeaderNavigation.vue?vue&type=template&id=70668a42&scoped=true"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js"

import "./HeaderNavigation.vue?vue&type=style&index=0&id=70668a42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70668a42"]])

export default __exports__